export default {
    freeImg: "https://web-data.zmlearn.com/image/3EkDGU1TBmwcyxvWxgWRXF/title_02.png",
    teacherIntro: [
        {
            tchImg: 'https://web-data.zmlearn.com/image/v7cXdKK85oadcEKBuRamQp/_png_04.png',
            title: 'Request',
            desc:
                'Tell us what you need to help with and our smart matching system will match you with an online tutor. Sign up for a free trial lesson.',
        },
        {
            tchImg: 'https://web-data.zmlearn.com/image/a742Udpxb7K85Rhey4PMVa/_png_05.png',
            title: 'Face to Face online tutoring',
            desc:
                'Receive video form tutoring via mobile phone or tablet, which incorporates chat, photo/homework upload, virtual whiteboard, document collaboration, and graphing. High-quality tutoring when & where you want. Digital whiteboard, recording function, screen sharing and much more included.',
        },
        {
            tchImg: 'https://web-data.zmlearn.com/image/qYFYcJ8VReioxkDXSXpdjq/_png_06.png',
            title: 'Review',
            desc:
                'After the lesson is completed, both the tutor and student have the opportunity to rate each other, maintaining the quality of our community.',
        },
    ],
}